import React from "react";
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, Radar } from "recharts";
import { Card, CardContent } from "@/components/ui/card";
import { useI18n } from "@/i18n";
import { Radar as RadarIcon } from "lucide-react";

// Multi-dimension fortune radar. Uses real indexes where present and falls
// back to the overall score so no dimension is fabricated from nothing.
export const FortuneRadar = ({ fortune }) => {
  const { t, L } = useI18n();
  const f = fortune || {};
  const base = Math.max(0, Math.min(100, Math.round(Number(f.score) || 60)));
  const val = (x) => {
    const n = Math.round(Number(x));
    return Number.isFinite(n) && n > 0 ? Math.max(0, Math.min(100, n)) : base;
  };
  const data = [
    { k: L("事业", "Career"), v: val(f.career_index) },
    { k: L("财运", "Wealth"), v: val(f.wealth_index) },
    { k: L("感情", "Love"), v: val(f.love_index) },
    { k: L("健康", "Health"), v: val(f.health_index) },
    { k: L("贵人", "Allies"), v: val(f.luck_index) },
    { k: L("出行", "Travel"), v: val(f.luck_index || f.score) },
  ];
  return (
    <Card className="border-border bg-card" data-testid="fortune-radar">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-1">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-[hsla(var(--brand-gold-soft),0.5)]">
            <RadarIcon className="h-3.5 w-3.5 text-[hsl(var(--brand-bronze))]" />
          </span>
          <span className="text-sm font-bold text-foreground">{L("运势雷达", "Fortune Radar")}</span>
        </div>
        <div className="h-[220px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart data={data} outerRadius="72%">
              <PolarGrid stroke="hsl(var(--border))" />
              <PolarAngleAxis dataKey="k" tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }} />
              <Radar dataKey="v" stroke="hsl(var(--brand-vermillion))" fill="hsl(var(--brand-gold))" fillOpacity={0.45} />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
